/**
 * A custom hook to extract query parameters from the URL using `react-router-dom`.
 * @param {object} location The location object containing the search string.
 * @returns {function(string): string|null} A function to retrieve a specific query parameter by name.
 * */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const useQueryParams = (location) => {
  // Parse the query string to extract query parameters
  const queryParams = new URLSearchParams(location.search)

  // Return the function to get query parameters
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  return (name) => queryParams.get(name)
}

export default useQueryParams
